var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgManropeV13Latin800(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Manrope",
    horizAdvX: 1131
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Manrope ExtraLight ExtraBold",
    unitsPerEm: 2000,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 2132,
    descent: -600,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 400
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 752,
    d: "M240 0V240H512V0H240ZM240 360V1440H512V360H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 984,
    d: "M120 1080V1440H392V1080H120ZM512 1080V1440H784V1080H512Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 1870,
    d: "M366 2L468 378H120L188 634H536L590 840H242L312 1094H658L752 1440H1016L922 1094H1138L1232 1440H1496L1402 1094H1750L1682 840H1334L1278 634H1626L1558 378H1210L1110 2H846L946 378H730L630 2H366ZM800 634H1014L1070 840H854L800 634Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 1282,
    d: "M516 -200V40H788V-200H516ZM516 1398V1638H788V1398H516ZM654 -30Q499 -30 377 27T178 190T80 440L350 482Q377 364 463 294T670 224Q783 224 857 277T932 408Q932 461 900 495T798 552L442 662Q134 757 134 1038Q134 1170 196 1267T373 1416T644 1468Q787 1466 898 1417T1083 1274T1192 1046L912 996Q898 1060 860 1108T766 1184T640 1214Q574 1216 521 1195T436 1137T404 1052Q404 1000 448 963T588 898L842 826Q1033 771 1117 677T1202 428Q1202 292 1133 189T941 28T654 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1800,
    d: "M360 0L180 180L1440 1440L1620 1258L360 0ZM1320 -30Q1221 -30 1140 18T1009 148T960 330Q960 428 1010 510T1142 641T1320 690Q1419 690 1501 642T1631 512T1680 330Q1680 230 1632 149T1501 19T1320 -30ZM1320 200Q1355 200 1384 218T1432 265T1450 330Q1450 365 1432 394T1385 442T1320 460Q1285 460 1256 442T1208 395T1190 330Q1190 295 1208 266T1255 218T1320 200ZM480 750Q381 750 299 798T169 928T120 1110Q120 1208 170 1290T302 1421T480 1470Q579 1470 660 1422T791 1292T840 1110Q840 1010 791 929T661 799T480 750ZM480 980Q515 980 544 998T592 1045T610 1110Q610 1145 592 1174T545 1222T480 1240Q445 1240 416 1222T368 1175T350 1110Q350 1075 368 1046T415 998T480 980Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1348,
    d: "M622 -30Q502 -30 394 6T214 120Q156 185 130 260T100 422Q100 508 125 586T202 726Q219 746 238 762T276 794Q222 856 195 916T168 1056Q168 1187 239 1290T434 1436Q485 1454 537 1460T638 1466Q737 1466 827 1436T980 1336Q1019 1296 1044 1247T1082 1148L812 1094Q800 1136 770 1166Q742 1195 704 1203T630 1212Q573 1212 530 1192Q485 1171 464 1137T442 1052Q442 1006 460 979T502 926Q519 908 544 884T598 834L928 528Q928 545 928 568T928 610V774H1164V500Q1164 454 1162 404T1152 320L1328 158L1154 -28L1022 98Q965 49 901 20T770 -20Q728 -26 693 -28T622 -30ZM634 228Q657 228 678 230T720 236Q752 242 778 253T826 280L474 604Q453 595 437 582T408 554Q392 532 383 503T374 438Q374 395 387 364T420 306Q453 264 516 246T634 228Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 552,
    d: "M120 1080V1440H392V1080H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 924,
    d: "M642 -388Q526 -252 444 -79T319 283T280 660Q276 847 318 1037T443 1399T642 1708L844 1560Q722 1413 653 1267T556 970T526 660Q527 501 555 351T653 54T844 -240L642 -388Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 924,
    d: "M282 -388L80 -240Q202 -93 271 53T368 350T398 660Q397 819 369 969T271 1266T80 1560L282 1708Q398 1572 480 1400T605 1037T644 660Q648 473 606 284T481 -79T282 -388Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 948,
    d: "M326 710L132 850L280 1018L60 1074L134 1302L342 1212L324 1440H564L546 1212L754 1302L828 1074L608 1018L756 850L562 710L444 900L326 710Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 1140,
    d: "M466 270V616H120V826H466V1170H676V826H1020V616H676V270H466Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 632,
    d: "M120 -270L136 -156Q184 -160 214 -141T255 -85T260 0H120V272H392V0Q392 -144 325 -218T120 -270Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 840,
    d: "M120 526V736H720V526H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 640,
    d: "M184 0V272H456V0H184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 896,
    d: "M504 1440H776L392 0H120L504 1440Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 1348,
    d: "M674 -30Q514 -30 394 37T207 224T140 504V936Q140 1096 207 1216T394 1403T674 1470Q834 1470 954 1403T1141 1216T1208 936V504Q1208 344 1141 224T954 37T674 -30ZM674 228Q746 228 804 262T896 354T930 484V958Q930 1030 896 1088T804 1180T674 1214Q602 1214 544 1180T452 1088T418 958V484Q418 412 452 354T544 262T674 228Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 908,
    d: "M390 0V1144L120 978V1278L390 1440H668V0H390Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 1208,
    d: "M100 2V238L704 774Q772 834 800 887T828 986Q828 1052 801 1103T725 1184T610 1214Q541 1214 489 1183T407 1100T380 988H100Q100 1136 165 1244T346 1411T616 1470Q757 1470 868 1409T1044 1237T1108 982Q1108 875 1078 805T989 675T844 540L454 198L432 258H1108V2H100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 1182,
    d: "M560 -26Q452 -26 354 17T184 140T80 326L344 396Q365 317 426 274T560 230Q622 230 673 260T755 341T786 454Q786 547 723 613T560 680Q530 680 502 672T448 648L326 862L784 1242L804 1184H136V1440H1036V1184L680 840L678 916Q802 897 887 830T1017 664T1062 454Q1062 318 993 210T810 38T560 -26Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 1230,
    d: "M726 0V224H100V478L554 1440H866L412 478H726V838H1002V478H1130V224H1002V0H726Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 1178,
    d: "M568 -30Q459 -30 364 15T199 140T100 326L362 396Q375 345 408 308T486 251T578 230Q640 230 691 260T773 341T804 454Q804 516 774 567T692 648T578 678Q502 678 454 653T382 604L152 674L196 1440H982V1186H346L442 1276L412 782L366 838Q420 882 489 902T618 922Q754 922 857 862T1019 696T1078 454Q1078 318 1007 209T820 35T568 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 1244,
    d: "M642 -30Q499 -30 386 37T206 223T140 500V918Q140 1088 206 1211T392 1401T674 1468Q779 1468 874 1437T1048 1332L854 1138Q818 1174 771 1194T674 1214Q596 1214 539 1178T450 1083T418 958V744L372 794Q434 857 515 890T684 924Q820 924 923 863T1085 696T1144 454Q1144 318 1075 209T892 35T642 -30ZM642 230Q704 230 755 260T837 341T868 454Q868 516 838 567T757 649T644 680Q582 680 531 650T449 568T418 454Q418 394 448 343T529 261T642 230Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 1088,
    d: "M212 0L696 1184H80V1440H988V1184L506 0H212Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 1246,
    d: "M622 -30Q476 -30 363 29T185 193T120 432Q120 546 171 647T320 812L314 728Q241 799 200 878T158 1056Q158 1181 217 1274T381 1418T622 1470Q758 1470 862 1419T1026 1274T1086 1056Q1086 957 1047 879T928 726V810Q1023 750 1074 648T1126 432Q1126 298 1061 194T882 30T622 -30ZM622 226Q718 226 778 278T838 432Q838 533 778 586T622 640Q526 640 467 587T408 432Q408 330 467 278T622 226ZM622 898Q700 898 749 936T798 1056Q798 1137 749 1176T622 1216Q544 1216 495 1177T446 1056Q446 975 495 937T622 898Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 1244,
    d: "M602 1468Q745 1468 858 1401T1038 1215T1104 938V520Q1104 350 1038 227T852 37T570 -30Q465 -30 371 1T196 106L390 300Q426 264 473 244T570 224Q648 224 705 260T794 355T826 480V694L872 644Q811 581 729 548T560 514Q424 514 321 575T159 742T100 984Q100 1120 169 1229T352 1403T602 1468ZM602 1208Q540 1208 489 1178T407 1097T376 984Q376 922 406 871T487 789T600 758Q662 758 713 788T795 870T826 984Q826 1044 796 1095T715 1177T602 1208Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 714,
    d: "M220 120V392H492V120H220ZM222 688V960H494V688H222Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 712,
    d: "M220 -270L236 -156Q284 -160 314 -141T355 -85T360 0H220V272H492V0Q492 -144 425 -218T220 -270ZM220 808V1080H492V808H220Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 1290,
    d: "M764 146L280 630L764 1114L932 946L604 630L932 314L764 146Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 1500,
    d: "M240 810V1020H1260V810H240ZM240 420V630H1260V420H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 1290,
    d: "M526 146L358 314L686 630L358 946L526 1114L1010 630L526 146Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 1126,
    d: "M394 390Q394 456 409 522T456 642Q481 693 510 722T578 783T670 870Q711 915 724 958T738 1054Q738 1081 733 1106T712 1150Q688 1183 649 1197T564 1212Q530 1212 498 1204T442 1178Q414 1157 401 1125T388 1054H100Q112 1161 161 1250T288 1390Q345 1428 414 1448T552 1468Q666 1468 767 1433T934 1316Q978 1265 1002 1198T1026 1062Q1026 953 977 864T856 698Q825 665 801 641T757 595T722 550Q694 504 688 475T682 390H394ZM396 0V288H682V0H396Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1834,
    d: "M912 -210Q744 -210 606 -157T368 -8T214 220T160 506Q160 709 220 857T384 1101T622 1243T900 1290Q1091 1290 1236 1233T1478 1077T1625 848T1674 574Q1674 375 1602 264T1350 152Q1272 152 1197 188T1092 296H1160Q1114 214 1042 183T894 152Q783 152 698 200T563 336T514 540Q514 659 565 746T704 880T898 928Q963 928 1034 902T1146 836L1104 778V900H1266L1262 506Q1262 428 1286 396T1350 364Q1401 364 1421 392T1444 468T1448 574Q1448 732 1395 831T1258 984T1085 1059T920 1080Q790 1080 689 1042T518 930T414 752T384 514Q389 388 428 292T537 131T705 33T922 0Q976 0 1029 9T1132 34L1200 -166Q1133 -188 1060 -199T912 -210ZM910 364Q975 364 1021 401T1068 540Q1068 626 1031 671T918 716Q827 716 784 668T740 540Q740 459 784 412T910 364Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1366,
    d: "M40 0L480 1440H886L1326 0H1046L654 1270H706L320 0H40ZM304 300V554H1064V300H304Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1274,
    d: "M140 0V1440H716Q870 1440 965 1379T1104 1224T1148 1036Q1148 915 1094 835T944 728V778Q1079 750 1146 653T1214 436Q1214 307 1167 209T1022 56T778 0H140ZM416 256H750Q805 256 848 279T915 345T940 446Q940 497 919 537T856 600T750 624H416V256ZM416 878H712Q758 878 794 894T851 943T872 1030Q872 1096 831 1141T712 1186H416V878Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1492,
    d: "M758 -30Q542 -30 386 64T145 327T60 720Q60 944 144 1113T385 1376T758 1470Q1006 1470 1174 1347T1412 1014L1138 938Q1098 1069 1003 1141T758 1214Q621 1214 530 1153T392 981T346 720Q346 570 392 459T529 287T758 226Q908 226 1003 299T1138 502L1412 426Q1343 216 1175 93T758 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1420,
    d: "M140 0V1440H606Q623 1440 676 1439T778 1432Q952 1411 1073 1311T1257 1057T1320 720Q1320 537 1257 383T1073 129T778 8Q729 2 676 1T606 0H140ZM416 256H606Q633 256 679 257T762 266Q856 285 915 354T1003 520T1032 720Q1032 828 1003 925T913 1089T762 1174Q725 1182 679 1183T606 1184H416V256Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1180,
    d: "M140 0V1440H1080V1186H412V878H960V624H412V254H1080V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1060,
    d: "M140 0V1440H1020V1168H412V856H900V584H412V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1482,
    d: "M740 -30Q604 -30 481 18T264 162T115 397T60 720Q60 959 151 1126T397 1382T740 1470Q1018 1470 1177 1341T1390 976L1112 936Q1073 1062 985 1137T758 1214Q621 1216 530 1155T394 982T348 720Q348 570 393 460T530 289T758 226Q851 224 926 258T1054 365T1128 552H900V762H1418Q1420 749 1421 716T1422 678Q1422 471 1338 311T1101 61T740 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1468,
    d: "M140 0V1440H412V848H1056V1440H1328V0H1056V594H412V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 592,
    d: "M160 0V1440H432V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 1026,
    d: "M442 -30Q270 -30 159 58T0 296L268 360Q277 305 326 265T430 224Q468 224 511 245T574 312Q586 341 588 383T590 480V1440H866V480Q866 411 866 360T856 265T818 172Q757 66 659 18T442 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1330,
    d: "M140 0V1440H412V776L960 1440H1292L690 730L1330 0H986L412 656V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1082,
    d: "M160 0V1440H432V254H1052V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1720,
    d: "M140 0V1440H384L860 484L1336 1440H1580V0H1326V860L908 0H812L394 860V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1458,
    d: "M140 0V1440H416L1042 480V1440H1318V0H1042L416 960V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1516,
    d: "M758 -30Q542 -30 386 64T145 327T60 720Q60 944 144 1113T385 1376T758 1470Q974 1470 1130 1376T1371 1113T1456 720Q1456 496 1372 327T1131 64T758 -30ZM758 226Q895 224 986 285T1122 458T1168 720Q1168 870 1123 980T986 1151T758 1214Q621 1216 530 1155T394 982T348 720Q348 570 393 460T530 289T758 226Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1300,
    d: "M140 0V1440H748Q769 1440 804 1439T868 1432Q997 1412 1079 1347T1201 1184T1240 964Q1240 843 1201 745T1079 581T868 496Q840 492 804 490T748 488H412V0H140ZM412 742H736Q757 742 782 744T828 752Q883 767 913 802T954 881T966 964Q966 1003 955 1046T913 1125T828 1176Q807 1182 782 1184T736 1186H412V742Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1516,
    d: "M1266 -30L846 388L1014 556L1432 138L1266 -30ZM758 -30Q542 -30 386 64T145 327T60 720Q60 944 144 1113T385 1376T758 1470Q974 1470 1130 1376T1371 1113T1456 720Q1456 496 1372 327T1131 64T758 -30ZM758 226Q895 224 986 285T1122 458T1168 720Q1168 870 1123 980T986 1151T758 1214Q621 1216 530 1155T394 982T348 720Q348 570 393 460T530 289T758 226Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1340,
    d: "M140 0V1440H748Q769 1440 804 1439T868 1432Q997 1412 1079 1347T1201 1184T1240 964Q1240 783 1150 655T868 496L748 488H412V0H140ZM952 0L668 586L948 640L1260 0H952ZM412 742H736Q757 742 782 744T828 752Q883 767 913 802T954 881T966 964Q966 1003 955 1046T913 1125T828 1176Q807 1182 782 1184T736 1186H412V742Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1342,
    d: "M684 -30Q524 -30 396 26T185 188T80 440L364 482Q394 358 488 291T702 224Q769 224 832 245T935 307T976 408Q976 430 970 450T948 489T906 523T836 552L462 662Q420 674 365 696T257 759T171 867T136 1038Q136 1183 209 1279T404 1422T674 1468Q823 1466 940 1417T1136 1275T1250 1046L956 996Q940 1066 897 1114T795 1187T670 1214Q606 1216 550 1197T458 1140T422 1052Q422 1005 451 976T524 928T614 898L864 830Q920 815 988 791T1118 723T1221 608T1262 428Q1262 312 1214 226T1083 83T898 -2T684 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1220,
    d: "M474 0V1186H20V1440H1200V1186H746V0H474Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1452,
    d: "M726 -30Q552 -30 420 40T214 239T140 540V1438L416 1440V542Q416 471 440 413T506 313T605 249T726 226Q792 226 848 249T947 314T1012 414T1036 542V1440H1312V540Q1312 367 1238 239T1032 41T726 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1306,
    d: "M450 0L10 1440H290L650 256L1016 1440H1296L856 0H450Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1978,
    d: "M442 0L20 1440H306L576 450L846 1438L1132 1440L1402 450L1672 1440H1958L1536 0H1268L989 972L710 0H442Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1344,
    d: "M20 0L504 728L34 1440H368L674 960L976 1440H1312L842 728L1324 0H990L674 496L356 0H20Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1260,
    d: "M492 0V586L0 1440H318L630 898L942 1440H1260L768 586V0H492Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1360,
    d: "M100 0V34L784 1186H160V1440H1260V1406L580 256H1240V0H100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 858,
    d: "M280 -420V1800H738V1560H520V-180H738V-420H280Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 896,
    d: "M392 1440L776 0H504L120 1440H392Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 858,
    d: "M578 -420H120V-180H338V1560H120V1800H578V-420Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 1368,
    d: "M211 986L694 1471L1179 987L1011 819L694 1147L379 818L211 986Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 1320,
    d: "M0 -254V-44H1320V-254H0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 1110,
    d: "M486 1590L320 1980H522L688 1590H486Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1166,
    d: "M440 -30Q324 -30 244 14T122 133T80 298Q80 373 103 435T177 544T316 624Q376 646 459 663T647 695T878 730L780 676Q780 772 734 817T580 862Q520 862 455 833T364 730L118 808Q159 942 272 1026T580 1110Q723 1110 834 1066T1002 914Q1034 854 1040 794T1046 660V0H808V222L842 176Q763 67 672 19T440 -30ZM498 184Q573 184 624 210T706 271T748 328Q769 372 772 430T776 528L856 508Q735 488 660 475T539 450T458 426Q418 410 394 392T358 351T346 302Q346 265 364 239T417 198T498 184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1248,
    d: "M670 -30Q509 -30 401 45T239 249T184 540Q184 702 238 831T397 1035T656 1110Q811 1110 926 1036T1104 834T1168 540Q1168 378 1106 249T931 45T670 -30ZM138 0V1440H412V740H378V0H138ZM626 212Q714 212 770 256T853 374T880 540Q880 630 852 704T766 823T616 868Q531 868 479 827T402 712T378 540Q378 442 402 368T480 253T626 212Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1166,
    d: "M616 -30Q448 -30 328 45T144 249T80 540Q80 704 146 833T334 1036T620 1110Q811 1110 940 1014T1106 750L834 678Q810 762 751 809T616 856Q530 856 475 815T394 702T368 540Q368 399 430 312T616 224Q708 224 756 266T828 386L1106 328Q1060 156 932 63T616 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1250,
    d: "M578 -30Q429 -30 317 45T143 249T80 540Q80 705 143 833T322 1036T592 1110Q746 1110 851 1035T1010 831T1064 540Q1064 378 1010 249T847 45T578 -30ZM622 212Q713 212 767 253T846 368T870 540Q870 638 846 712T770 827T632 868Q541 868 483 824T396 705T368 540Q368 449 395 375T478 256T622 212ZM870 0V740H836V1440H1110V0H870Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1216,
    d: "M642 -30Q476 -30 350 41T152 238T80 526Q80 703 150 834T343 1037T626 1110Q796 1110 915 1030T1091 805T1131 464H862V564Q862 729 810 801T638 874Q499 874 434 790T368 540Q368 389 433 307T626 224Q706 224 763 259T850 360L1122 282Q1061 134 930 52T642 -30ZM284 464V666H1000V464H284Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 772,
    d: "M230 0V1076Q230 1117 232 1169T248 1274T302 1370Q352 1426 410 1446T524 1468T618 1470H752V1250H628Q564 1250 533 1218T502 1140V0H230ZM60 870V1080H752V870H60Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1248,
    d: "M602 -510Q510 -510 427 -481T279 -399T172 -276L424 -154Q450 -202 498 -227T604 -252Q665 -252 719 -232T805 -171T836 -70V244H870V1080H1108V-74Q1108 -114 1105 -149T1092 -220Q1066 -319 996 -383T823 -478T602 -510ZM578 -30Q429 -30 317 45T143 249T80 540Q80 705 143 833T322 1036T592 1110Q746 1110 851 1035T1010 831T1064 540Q1064 378 1010 249T847 45T578 -30ZM622 212Q713 212 767 253T846 368T870 540Q870 638 846 712T770 827T632 868Q541 868 483 824T396 705T368 540Q368 449 395 375T478 256T622 212Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1272,
    d: "M876 0V510Q876 547 872 604T847 720T779 817T644 856Q609 856 569 845T494 803T437 710T414 548L258 622Q258 750 310 862T466 1043T730 1112Q857 1112 937 1069T1061 960T1125 823T1148 692T1152 606V0H876ZM138 0V1440H380V700H414V0H138Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 592,
    d: "M160 1230V1470H432V1230H160ZM160 0V1080H432V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 602,
    d: "M-20 -480V-226H28Q121 -226 155 -184T190 -64V1080H462V-196Q462 -325 382 -402T164 -480H-20ZM190 1230V1470H462V1230H190Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1104,
    d: "M138 0L140 1440H416V560L782 1080H1118L728 540L1144 0H790L416 520V0H138Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 592,
    d: "M160 0V1470H432V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1832,
    d: "M1440 0V638Q1440 745 1390 804T1250 864Q1193 864 1151 838T1086 764T1062 654L948 730Q948 841 1000 926T1141 1058T1338 1106Q1523 1106 1617 997T1712 710V0H1440ZM138 0V1080H378V722H412V0H138ZM790 0V638Q790 745 740 804T600 864Q515 864 464 806T412 654L298 734Q298 840 351 924T493 1057T694 1106Q821 1106 902 1052T1023 908T1062 710V0H790Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1272,
    d: "M876 0V510Q876 547 872 604T847 720T779 817T644 856Q609 856 569 845T494 803T437 710T414 548L258 622Q258 750 310 862T466 1043T730 1112Q857 1112 937 1069T1061 960T1125 823T1148 692T1152 606V0H876ZM138 0V1080H380V722H414V0H138Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1254,
    d: "M626 -30Q463 -30 340 43T149 244T80 540Q80 709 150 837T343 1038T626 1110Q789 1110 912 1037T1105 836T1174 540Q1174 372 1105 244T912 43T626 -30ZM626 224Q757 224 821 312T886 540Q886 684 821 770T626 856Q537 856 480 816T396 705T368 540Q368 395 433 310T626 224Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1248,
    d: "M670 -30Q509 -30 401 45T239 249T184 540Q184 702 238 831T397 1035T656 1110Q811 1110 926 1036T1104 834T1168 540Q1168 378 1106 249T931 45T670 -30ZM138 -480V1080H378V340H412V-480H138ZM626 212Q714 212 770 256T853 374T880 540Q880 630 852 704T766 823T616 868Q531 868 479 827T402 712T378 540Q378 442 402 368T480 253T626 212Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1250,
    d: "M578 -30Q429 -30 317 45T143 249T80 540Q80 705 143 833T322 1036T592 1110Q746 1110 851 1035T1010 831T1064 540Q1064 378 1010 249T847 45T578 -30ZM622 212Q713 212 767 253T846 368T870 540Q870 638 846 712T770 827T632 868Q541 868 483 824T396 705T368 540Q368 449 395 375T478 256T622 212ZM836 -480V340H870V1080H1110V-480H836Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 824,
    d: "M140 0V1080H380V816L354 850Q375 906 410 952T496 1028Q535 1052 581 1065T676 1082T774 1080V826Q729 840 670 836T562 808Q514 786 481 750T431 664T414 552V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 1094,
    d: "M562 -30Q358 -30 233 62T80 324L358 366Q375 290 433 247T582 204Q656 204 696 232T736 312Q736 344 720 363T649 402T476 452Q344 486 265 528T151 628T116 770Q116 874 169 950T318 1068T546 1110Q673 1110 771 1071T929 960T1004 790L726 740Q719 800 674 835T552 876Q477 881 432 856T386 784Q386 756 405 737T486 698T674 646Q797 614 871 572T980 470T1014 326Q1014 160 894 65T562 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 888,
    d: "M788 0Q676 -21 569 -19T377 19T248 134Q208 208 206 284T204 458V1380H476V474Q476 411 477 361T498 280Q534 223 613 218T788 226V0ZM20 870V1080H788V870H20Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1272,
    d: "M542 -32Q415 -32 335 11T211 120T147 257T124 388T120 474V1080H396V570Q396 533 400 476T425 360T493 263T628 224Q663 224 703 235T778 277T835 370T858 532L1014 458Q1014 330 962 218T806 37T542 -32ZM892 0V358H858V1080H1132V0H892Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1136,
    d: "M432 0L40 1080H312L568 332L824 1080H1096L704 0H432Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1628,
    d: "M370 0L40 1082L306 1080L502 436L701 1080H927L1126 436L1322 1080H1588L1258 0H1050L814 704L578 0H370Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 1126,
    d: "M20 0L406 546L28 1080H348L564 760L776 1080H1096L718 546L1106 0H786L564 332L340 0H20Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1140,
    d: "M278 -480L486 92L490 -76L20 1080H302L618 262H554L868 1080H1140L530 -480H278Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 1070,
    d: "M40 0V34L570 844H100V1080H990V1046L462 236H970V0H40Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 918,
    d: "M696 -420Q558 -420 480 -342T402 -126V458Q402 477 392 490L302 618Q280 651 280 690T302 762L392 890Q402 907 402 922V1506Q402 1643 480 1721T696 1800H838V1544H716Q692 1544 675 1527T658 1486V922Q658 824 600 742L562 690L600 638Q658 556 658 458V-106Q658 -131 675 -148T716 -166H838V-420H696Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 632,
    d: "M180 0V1440H452V0H180Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 918,
    d: "M222 -420H80V-166H202Q226 -166 243 -149T260 -106V458Q260 556 318 638L356 690L318 742Q260 824 260 922V1486Q260 1510 243 1527T202 1544H80V1800H222Q360 1800 438 1722T516 1506V922Q516 907 526 890L616 762Q639 729 639 690T616 618L526 490Q516 477 516 458V-126Q516 -264 438 -342T222 -420Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 1468,
    d: "M976 390Q907 390 844 421T725 494T619 567T528 599Q486 599 469 552T472 432H235Q205 555 222 654T306 813T491 872Q560 872 623 841T743 768T849 695T940 663Q982 663 998 710T996 830H1233Q1262 707 1245 608T1162 449T976 390Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 400
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 752,
    d: "M240 1080H512V840H240V1080ZM240 720H512V-360H240V720Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 1166,
    d: "M524 -58V126Q384 147 285 225T133 423T80 690Q80 837 134 956T287 1153T524 1252V1440H734V1250Q880 1223 978 1132T1106 900L834 828Q810 912 751 959T616 1006Q530 1006 475 965T394 852T368 690Q368 549 430 462T616 374Q708 374 756 416T828 536L1106 478Q1067 334 971 246T734 130V-58H524Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    horizAdvX: 1142,
    d: "M80 0V254H82Q144 254 188 300T232 406V1082Q232 1192 288 1280T439 1419T650 1470Q758 1470 836 1422T970 1290T1062 1102L818 1022Q793 1109 755 1161T650 1214Q587 1214 549 1173T510 1068L508 254H954V0H80ZM80 592V848H792V592H80Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    horizAdvX: 1360,
    d: "M680 196Q572 196 477 237T310 350T197 518T156 722Q156 830 197 925T310 1092T477 1205T680 1246Q789 1246 884 1205T1051 1092T1165 925T1206 722Q1206 613 1165 518T1052 351T884 237T680 196ZM240 100L60 280L314 534L496 354L240 100ZM314 904L60 1158L240 1340L494 1086L314 904ZM1120 100L866 354L1046 534L1300 280L1120 100ZM680 424Q762 424 829 464T936 572T976 720Q976 802 936 869T828 976T680 1016Q598 1016 531 976T424 869T384 720Q384 640 424 573T531 465T680 424ZM1048 906L866 1086L1120 1340L1300 1158L1048 906Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    horizAdvX: 1260,
    d: "M210 526V736H1050V526H210ZM210 188V398H1050V188H210ZM492 0V586L0 1440H318L630 898L942 1440H1260L768 586V0H492Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 632,
    d: "M180 600V1440H452V600H180ZM180 -440V400H452V-440H180Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 1094,
    d: "M560 -270Q442 -270 345 -232T184 -116T100 84L378 126Q389 73 418 37T489 -17T578 -36Q613 -36 644 -25T696 10T716 72Q716 109 693 130T612 169T456 212Q335 243 255 283T136 379T96 510Q96 610 155 671T305 761T486 790L512 676Q439 651 403 623T366 550Q366 508 400 486T498 448T654 406Q769 374 844 335T957 238T994 90Q994 -27 938 -107T783 -228T560 -270ZM610 274L602 384Q635 394 666 414T716 464T736 532Q736 569 713 590T632 629T476 672Q355 703 275 742T156 841T116 990Q116 1108 176 1183T328 1294T520 1330Q621 1330 712 1294T866 1187T944 1010L666 960Q658 1006 640 1036T590 1082T512 1098Q477 1098 449 1089T403 1060T386 1010Q386 967 422 945T523 906T674 866Q788 834 863 796T976 701T1014 558Q1014 459 966 393T828 296T610 274Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 1144,
    d: "M664 1592V1832H904V1592H664ZM240 1592V1832H480V1592H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1828,
    d: "M914 -140Q737 -140 582 -74T310 110T127 382T60 714Q60 891 126 1046T310 1318T582 1501T914 1568Q1091 1568 1246 1502T1518 1318T1701 1046T1768 714Q1768 537 1702 382T1518 110T1246 -73T914 -140ZM932 286Q829 286 757 318T628 420Q576 486 552 559T528 714Q528 800 553 873T628 1006Q684 1074 758 1108T942 1142Q999 1142 1046 1131T1144 1088Q1201 1054 1241 1000T1298 872L1094 818Q1087 845 1073 869T1034 914Q1012 934 986 943T930 952Q885 952 851 934T790 884Q763 850 754 806T744 714Q744 668 754 625T790 546Q814 513 849 496T934 478Q1004 478 1038 512Q1059 533 1070 553T1090 598L1298 556Q1282 498 1249 446T1166 356Q1121 322 1067 304T932 286ZM914 114Q1039 114 1147 160T1338 289T1467 481T1514 714Q1514 839 1468 947T1339 1138T1148 1267T914 1314Q790 1314 681 1268T490 1139T361 948T314 714Q314 590 360 481T489 290T681 161T914 114Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    horizAdvX: 643,
    d: "M260 540Q173 540 127 588T80 704Q80 760 106 801T198 867Q243 884 314 895T479 920L430 893Q430 941 407 963T330 986Q300 986 268 972T222 920L99 959Q119 1026 176 1068T330 1110Q401 1110 457 1088T541 1012Q557 982 560 952T563 885V555H444V666L461 643Q421 588 376 564T260 540ZM289 647Q345 647 375 674T414 719Q425 741 426 770T428 819L468 809Q377 794 336 786T269 768Q239 756 226 741T213 706Q213 678 233 663T289 647Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1206,
    d: "M944 94L590 540L944 986L1086 874L820 540L1086 206L944 94ZM514 94L160 540L514 986L656 874L390 540L656 206L514 94Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    horizAdvX: 1200,
    d: "M870 366V596H120V806H1080V366H870Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 840,
    d: "M120 526V736H720V526H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 1330,
    d: "M664 536Q556 536 461 577T294 690T181 858T140 1062Q140 1170 181 1265T294 1432T461 1545T664 1586Q773 1586 868 1545T1035 1432T1149 1265T1190 1062Q1190 953 1149 858T1036 691T868 577T664 536ZM666 712Q761 712 840 760T968 887T1016 1062Q1016 1159 968 1238T841 1365T666 1412Q569 1412 490 1365T363 1239T316 1062Q316 967 363 888T489 760T666 712ZM498 824V1300H698Q775 1300 817 1257T862 1142Q862 1099 842 1063T780 1002L868 824H766L688 986H588V824H498ZM588 1070H702Q732 1070 751 1090T770 1142Q770 1177 754 1195T702 1214H588V1070Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 1024,
    d: "M240 1680V1888H784V1680H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 900,
    d: "M420 750Q321 750 239 798T109 928T60 1110Q60 1208 110 1290T242 1421T420 1470Q519 1470 600 1422T731 1292T780 1110Q780 1010 731 929T601 799T420 750ZM420 980Q455 980 484 998T532 1045T550 1110Q550 1145 532 1174T485 1222T420 1240Q385 1240 356 1222T308 1175T290 1110Q290 1075 308 1046T355 998T420 980Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    horizAdvX: 1200,
    d: "M496 440V656H120V866H496V1080H706V866H1080V656H706V440H496ZM120 120V330H1080V120H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    horizAdvX: 832,
    d: "M100 540V688L478 1024Q520 1062 538 1095T556 1156Q556 1219 519 1259T420 1300Q377 1300 344 1281T293 1229T276 1158H100Q100 1251 140 1318T254 1423T424 1460Q512 1460 581 1422T691 1314T732 1154Q732 1087 713 1043T657 962T566 878L322 662L308 700H732V540H100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    horizAdvX: 818,
    d: "M382 518Q280 518 195 578T80 740L246 784Q260 733 298 707T382 680Q441 680 482 721T524 820Q524 879 484 920T382 962Q363 962 345 957T312 942L234 1076L522 1316L536 1278H116V1440H682V1278L458 1062L456 1110Q534 1098 588 1056T670 952T698 820Q698 734 655 666T539 558T382 518Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 1110,
    d: "M624 1590H422L588 1980H790L624 1590Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    horizAdvX: 1290,
    d: "M138 -480V1080H414V570Q414 533 418 476T443 360T511 263T646 224Q681 224 721 235T796 277T853 370T876 532V1080H1150V0H910V112Q852 46 765 7T560 -32Q506 -32 461 -24T378 0V-480H138Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1484,
    d: "M668 -282V488H572Q566 488 530 489T452 496Q326 514 244 579T121 743T80 964Q80 1083 119 1182T241 1348T452 1432Q494 1438 529 1439T572 1440H940V-282H668ZM1132 -282V1440H1404V-282H1132Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 560,
    d: "M284 470Q215 470 168 515T120 630Q120 699 167 744T284 790Q347 790 393 745T440 630Q440 561 394 516T284 470Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 838,
    d: "M382 -484Q340 -484 305 -473T240 -446L298 -290Q337 -302 358 -302Q385 -302 399 -287T414 -256Q414 -220 376 -203T284 -170L354 34L512 36L476 -72Q535 -102 566 -149T598 -262Q598 -361 534 -422T382 -484Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    horizAdvX: 703,
    d: "M289 540V1255L120 1151V1339L289 1440H463V540H289Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    horizAdvX: 707,
    d: "M353 540Q231 540 156 620T80 825Q80 952 156 1031T353 1110Q475 1110 551 1030T627 825Q627 699 551 620T353 540ZM353 667Q418 667 450 711T483 825Q483 897 451 940T353 983Q286 983 255 940T224 825Q224 752 256 710T353 667Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1206,
    d: "M262 94L120 206L386 540L120 874L262 986L616 540L262 94ZM692 94L550 206L816 540L550 874L692 986L1046 540L692 94Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    horizAdvX: 2112,
    d: "M289 540V1255L120 1151V1339L289 1440H463V540H289ZM1620 0V140H1228V300L1512 900H1708L1424 300H1620V524H1792V300H1872V140H1792V0H1620ZM571 0L417 114L1381 1454L1535 1338L571 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    horizAdvX: 2081,
    d: "M289 540V1255L120 1151V1339L289 1440H463V540H289ZM1349 0V148L1727 484Q1769 522 1787 555T1805 616Q1805 679 1768 719T1669 760Q1626 760 1593 741T1542 689T1525 618H1349Q1349 711 1389 779T1503 883T1673 920Q1761 920 1830 882T1940 774T1981 614Q1981 547 1962 503T1906 422T1815 338L1571 122L1557 160H1981V0H1349ZM571 0L417 114L1381 1454L1535 1338L571 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    horizAdvX: 2088,
    d: "M382 518Q280 518 195 578T80 740L246 784Q260 733 298 707T382 680Q441 680 482 721T524 820Q524 879 484 920T382 962Q363 962 345 957T312 942L234 1076L522 1316L536 1278H116V1440H682V1278L458 1062L456 1110Q534 1098 588 1056T670 952T698 820Q698 734 655 666T539 558T382 518ZM1716 0V140H1324V300L1608 900H1804L1520 300H1716V524H1888V300H1968V140H1888V0H1716ZM686 0L532 114L1496 1454L1650 1338L686 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 1126,
    d: "M732 690Q732 624 717 558T670 438Q645 387 616 358T548 297T456 210Q416 165 402 122T388 26Q388 -1 393 -25T414 -70Q438 -103 477 -117T562 -132Q597 -132 629 -124T684 -98Q713 -77 726 -45T738 26H1026Q1014 -80 965 -169T838 -310Q781 -347 712 -367T574 -388Q460 -388 359 -353T192 -236Q149 -185 125 -117T100 18Q100 128 149 217T270 382Q301 415 325 439T369 485T404 530Q433 577 438 606T444 690H732ZM730 1080V792H444V1080H730Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 1366,
    d: "M554 1590L388 1980H590L756 1590H554ZM1326 0H1046L660 1270H712L320 0H40L480 1440H886L1326 0ZM1062 300H302V554H1062V300Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 1366,
    d: "M812 1590H610L776 1980H978L812 1590ZM40 0L480 1440H886L1326 0H1046L654 1270H706L320 0H40ZM304 300V554H1064V300H304Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 1366,
    d: "M280 1590L568 1920H792L1080 1590H830L680 1770L530 1590H280ZM40 0L480 1440H886L1326 0H1046L654 1270H706L320 0H40ZM304 300V554H1064V300H304Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 1366,
    d: "M856 1646Q807 1646 763 1668T678 1720T602 1771T538 1794Q508 1794 497 1761T498 1676H330Q299 1807 342 1897T512 1988Q561 1988 605 1966T690 1914T766 1863T830 1840Q860 1840 872 1873T870 1958H1038Q1070 1828 1026 1737T856 1646ZM40 0L480 1440H886L1326 0H1046L654 1270H706L320 0H40ZM304 300V554H1064V300H304Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 1366,
    d: "M776 1592V1832H1016V1592H776ZM352 1592V1832H592V1592H352ZM40 0L480 1440H886L1326 0H1046L654 1270H706L320 0H40ZM304 300V554H1064V300H304Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 1366,
    d: "M684 1550Q610 1550 549 1586T451 1684T414 1820Q414 1895 450 1956T548 2053T684 2090Q759 2090 820 2054T917 1956T954 1820Q954 1746 918 1685T820 1587T684 1550ZM684 1710Q730 1710 762 1742T794 1820Q794 1866 762 1898T684 1930Q639 1930 607 1898T574 1820Q574 1775 606 1743T684 1710ZM40 0L480 1440H886L1326 0H1046L654 1270H706L320 0H40ZM304 300V554H1064V300H304Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 1890,
    d: "M40 0L480 1440H940V1186H590L706 1272L320 0H40ZM304 300V554H1064V300H304ZM850 0V1440H1790V1186H1122V878H1670V624H1122V254H1790V0H850Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1492,
    d: "M734 -484Q692 -484 657 -473T592 -446L650 -290Q689 -302 710 -302Q737 -302 751 -287T766 -256Q766 -220 728 -203T636 -170L706 34L864 36L828 -72Q887 -102 918 -149T950 -262Q950 -361 886 -422T734 -484ZM758 -30Q542 -30 386 64T145 327T60 720Q60 944 144 1113T385 1376T758 1470Q1006 1470 1174 1347T1412 1014L1138 938Q1098 1069 1003 1141T758 1214Q621 1214 530 1153T392 981T346 720Q346 570 392 459T529 287T758 226Q908 226 1003 299T1138 502L1412 426Q1343 216 1175 93T758 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1180,
    d: "M526 1590L360 1980H562L728 1590H526ZM140 0V1440H1080V1186H412V878H960V624H412V254H1080V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1180,
    d: "M739 1590H537L703 1980H905L739 1590ZM140 0V1440H1080V1186H412V878H960V624H412V254H1080V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1180,
    d: "M196 1590L484 1920H708L996 1590H746L596 1770L446 1590H196ZM140 0V1440H1080V1186H412V878H960V624H412V254H1080V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1180,
    d: "M700 1592V1832H940V1592H700ZM276 1592V1832H516V1592H276ZM140 0V1440H1080V1186H412V878H960V624H412V254H1080V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 592,
    d: "M191 1590L25 1980H227L393 1590H191ZM160 0V1440H432V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 592,
    d: "M401 1590H199L365 1980H567L401 1590ZM160 0V1440H432V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 592,
    d: "M-108 1590L180 1920H404L692 1590H442L292 1770L142 1590H-108ZM160 0V1440H432V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 592,
    d: "M388 1592V1832H628V1592H388ZM-36 1592V1832H204V1592H-36ZM160 0V1440H432V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1428,
    d: "M20 616V826H710V616H20ZM148 0V1440H614Q631 1440 684 1439T786 1432Q960 1411 1081 1311T1265 1057T1328 720Q1328 537 1265 383T1081 129T786 8Q737 2 684 1T614 0H148ZM424 256H614Q641 256 687 257T770 266Q864 285 923 354T1011 520T1040 720Q1040 828 1011 925T921 1089T770 1174Q733 1182 687 1183T614 1184H424V256Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1458,
    d: "M922 1596Q873 1596 829 1618T744 1670T668 1721T604 1744Q574 1744 563 1711T564 1626H396Q365 1757 408 1847T578 1938Q627 1938 671 1916T756 1864T832 1813T896 1790Q926 1790 938 1823T936 1908H1104Q1136 1778 1092 1687T922 1596ZM140 0V1440H416L1042 480V1440H1318V0H1042L416 960V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 1516,
    d: "M629 1590L463 1980H665L831 1590H629ZM758 -30Q542 -30 386 64T145 327T60 720Q60 944 144 1113T385 1376T758 1470Q974 1470 1130 1376T1371 1113T1456 720Q1456 496 1372 327T1131 64T758 -30ZM758 226Q895 224 986 285T1122 458T1168 720Q1168 870 1123 980T986 1151T758 1214Q621 1216 530 1155T394 982T348 720Q348 570 393 460T530 289T758 226Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 1516,
    d: "M867 1590H665L831 1980H1033L867 1590ZM758 -30Q542 -30 386 64T145 327T60 720Q60 944 144 1113T385 1376T758 1470Q974 1470 1130 1376T1371 1113T1456 720Q1456 496 1372 327T1131 64T758 -30ZM758 226Q895 224 986 285T1122 458T1168 720Q1168 870 1123 980T986 1151T758 1214Q621 1216 530 1155T394 982T348 720Q348 570 393 460T530 289T758 226Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 1516,
    d: "M354 1590L642 1920H866L1154 1590H904L754 1770L604 1590H354ZM758 -30Q542 -30 386 64T145 327T60 720Q60 944 144 1113T385 1376T758 1470Q974 1470 1130 1376T1371 1113T1456 720Q1456 496 1372 327T1131 64T758 -30ZM758 226Q895 224 986 285T1122 458T1168 720Q1168 870 1123 980T986 1151T758 1214Q621 1216 530 1155T394 982T348 720Q348 570 393 460T530 289T758 226Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 1516,
    d: "M758 -30Q542 -30 386 64T145 327T60 720Q60 944 144 1113T385 1376T758 1470Q974 1470 1130 1376T1371 1113T1456 720Q1456 496 1372 327T1131 64T758 -30ZM758 226Q895 224 986 285T1122 458T1168 720Q1168 870 1123 980T986 1151T758 1214Q621 1216 530 1155T394 982T348 720Q348 570 393 460T530 289T758 226ZM942 1596Q893 1596 849 1618T764 1670T688 1721T624 1744Q594 1744 583 1711T584 1626H416Q385 1757 428 1847T598 1938Q647 1938 691 1916T776 1864T852 1813T916 1790Q946 1790 958 1823T956 1908H1124Q1156 1778 1112 1687T942 1596Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 1516,
    d: "M850 1592V1832H1090V1592H850ZM426 1592V1832H666V1592H426ZM758 -30Q542 -30 386 64T145 327T60 720Q60 944 144 1113T385 1376T758 1470Q974 1470 1130 1376T1371 1113T1456 720Q1456 496 1372 327T1131 64T758 -30ZM758 226Q895 224 986 285T1122 458T1168 720Q1168 870 1123 980T986 1151T758 1214Q621 1216 530 1155T394 982T348 720Q348 570 393 460T530 289T758 226Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    horizAdvX: 1026,
    d: "M758 328L513 573L268 328L120 477L364 722L121 965L270 1113L513 870L756 1113L905 965L661 722L906 477L758 328Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 1516,
    d: "M286 -26L94 144L252 324L286 354L1064 1232L1076 1254L1264 1466L1456 1294L1250 1062L1224 1044L444 162L430 138L286 -26ZM758 -30Q542 -30 386 64T145 327T60 720Q60 944 144 1113T385 1376T758 1470Q974 1470 1130 1376T1371 1113T1456 720Q1456 496 1372 327T1131 64T758 -30ZM758 226Q895 224 986 285T1122 458T1168 720Q1168 870 1123 980T986 1151T758 1214Q621 1216 530 1155T394 982T348 720Q348 570 393 460T530 289T758 226Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1452,
    d: "M642 1590L476 1980H678L844 1590H642ZM726 -30Q552 -30 420 40T214 239T140 540V1438L416 1440V542Q416 471 440 413T506 313T605 249T726 226Q792 226 848 249T947 314T1012 414T1036 542V1440H1312V540Q1312 367 1238 239T1032 41T726 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1452,
    d: "M825 1590H623L789 1980H991L825 1590ZM726 -30Q552 -30 420 40T214 239T140 540V1438L416 1440V542Q416 471 440 413T506 313T605 249T726 226Q792 226 848 249T947 314T1012 414T1036 542V1440H1312V540Q1312 367 1238 239T1032 41T726 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1452,
    d: "M322 1590L610 1920H834L1122 1590H872L722 1770L572 1590H322ZM726 -30Q552 -30 420 40T214 239T140 540V1438L416 1440V542Q416 471 440 413T506 313T605 249T726 226Q792 226 848 249T947 314T1012 414T1036 542V1440H1312V540Q1312 367 1238 239T1032 41T726 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1452,
    d: "M818 1592V1832H1058V1592H818ZM394 1592V1832H634V1592H394ZM726 -30Q552 -30 420 40T214 239T140 540V1438L416 1440V542Q416 471 440 413T506 313T605 249T726 226Q792 226 848 249T947 314T1012 414T1036 542V1440H1312V540Q1312 367 1238 239T1032 41T726 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1260,
    d: "M730 1590H528L694 1980H896L730 1590ZM492 0V586L0 1440H318L630 898L942 1440H1260L768 586V0H492Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1284,
    d: "M140 0V1440H416V1196H742Q816 1196 888 1174Q960 1152 1022 1108T1128 1002Q1173 942 1198 869T1224 720Q1226 645 1200 572T1128 438Q1065 351 963 299T742 246H416V0H140ZM416 500H740Q781 500 827 523T904 588Q925 617 937 650T948 720Q947 759 935 796T896 862Q868 895 825 917T740 940H416V500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1292,
    d: "M710 -30Q644 -30 602 -23T524 0V266Q550 256 587 246T670 236Q775 236 837 284T900 432Q900 546 816 595T598 644V880Q659 884 700 905T763 964T784 1052Q784 1130 726 1173T596 1216Q548 1216 507 1198T438 1132Q425 1108 419 1069T412 986V0H138V1060Q138 1098 141 1128T154 1188Q185 1289 252 1351T409 1441T596 1470Q724 1470 829 1416T996 1269T1058 1058Q1058 982 1033 916T954 798Q1007 776 1047 740T1115 655T1157 549T1172 428Q1172 214 1053 92T710 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1166,
    d: "M494 1230L328 1620H530L696 1230H494ZM440 -30Q324 -30 244 14T122 133T80 298Q80 373 103 435T177 544T316 624Q376 646 459 663T647 695T878 730L780 676Q780 772 734 817T580 862Q520 862 455 833T364 730L118 808Q159 942 272 1026T580 1110Q723 1110 834 1066T1002 914Q1034 854 1040 794T1046 660V0H808V222L842 176Q763 67 672 19T440 -30ZM498 184Q573 184 624 210T706 271T748 328Q769 372 772 430T776 528L856 508Q735 488 660 475T539 450T458 426Q418 410 394 392T358 351T346 302Q346 265 364 239T417 198T498 184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1166,
    d: "M705 1230H503L669 1620H871L705 1230ZM440 -30Q324 -30 244 14T122 133T80 298Q80 373 103 435T177 544T316 624Q376 646 459 663T647 695T878 730L780 676Q780 772 734 817T580 862Q520 862 455 833T364 730L118 808Q159 942 272 1026T580 1110Q723 1110 834 1066T1002 914Q1034 854 1040 794T1046 660V0H808V222L842 176Q763 67 672 19T440 -30ZM498 184Q573 184 624 210T706 271T748 328Q769 372 772 430T776 528L856 508Q735 488 660 475T539 450T458 426Q418 410 394 392T358 351T346 302Q346 265 364 239T417 198T498 184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1166,
    d: "M196 1230L484 1560H708L996 1230H746L596 1410L446 1230H196ZM440 -30Q324 -30 244 14T122 133T80 298Q80 373 103 435T177 544T316 624Q376 646 459 663T647 695T878 730L780 676Q780 772 734 817T580 862Q520 862 455 833T364 730L118 808Q159 942 272 1026T580 1110Q723 1110 834 1066T1002 914Q1034 854 1040 794T1046 660V0H808V222L842 176Q763 67 672 19T440 -30ZM498 184Q573 184 624 210T706 271T748 328Q769 372 772 430T776 528L856 508Q735 488 660 475T539 450T458 426Q418 410 394 392T358 351T346 302Q346 265 364 239T417 198T498 184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1166,
    d: "M790 1236Q741 1236 697 1258T612 1310T536 1361T472 1384Q442 1384 431 1351T432 1266H264Q233 1397 276 1487T446 1578Q495 1578 539 1556T624 1504T700 1453T764 1430Q794 1430 806 1463T804 1548H972Q1004 1418 960 1327T790 1236ZM440 -30Q324 -30 244 14T122 133T80 298Q80 373 103 435T177 544T316 624Q376 646 459 663T647 695T878 730L780 676Q780 772 734 817T580 862Q520 862 455 833T364 730L118 808Q159 942 272 1026T580 1110Q723 1110 834 1066T1002 914Q1034 854 1040 794T1046 660V0H808V222L842 176Q763 67 672 19T440 -30ZM498 184Q573 184 624 210T706 271T748 328Q769 372 772 430T776 528L856 508Q735 488 660 475T539 450T458 426Q418 410 394 392T358 351T346 302Q346 265 364 239T417 198T498 184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1166,
    d: "M692 1232V1472H932V1232H692ZM268 1232V1472H508V1232H268ZM440 -30Q324 -30 244 14T122 133T80 298Q80 373 103 435T177 544T316 624Q376 646 459 663T647 695T878 730L780 676Q780 772 734 817T580 862Q520 862 455 833T364 730L118 808Q159 942 272 1026T580 1110Q723 1110 834 1066T1002 914Q1034 854 1040 794T1046 660V0H808V222L842 176Q763 67 672 19T440 -30ZM498 184Q573 184 624 210T706 271T748 328Q769 372 772 430T776 528L856 508Q735 488 660 475T539 450T458 426Q418 410 394 392T358 351T346 302Q346 265 364 239T417 198T498 184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1166,
    d: "M596 1190Q522 1190 461 1226T363 1324T326 1460Q326 1535 362 1596T460 1693T596 1730Q671 1730 732 1694T829 1596T866 1460Q866 1386 830 1325T732 1227T596 1190ZM596 1350Q642 1350 674 1382T706 1460Q706 1506 674 1538T596 1570Q551 1570 519 1538T486 1460Q486 1415 518 1383T596 1350ZM440 -30Q324 -30 244 14T122 133T80 298Q80 373 103 435T177 544T316 624Q376 646 459 663T647 695T878 730L780 676Q780 772 734 817T580 862Q520 862 455 833T364 730L118 808Q159 942 272 1026T580 1110Q723 1110 834 1066T1002 914Q1034 854 1040 794T1046 660V0H808V222L842 176Q763 67 672 19T440 -30ZM498 184Q573 184 624 210T706 271T748 328Q769 372 772 430T776 528L856 508Q735 488 660 475T539 450T458 426Q418 410 394 392T358 351T346 302Q346 265 364 239T417 198T498 184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1868,
    d: "M1321 -30Q1161 -30 1042 42T856 239T790 526Q790 701 854 832T1035 1037T1306 1110Q1473 1110 1584 1027T1747 798T1784 464H1529V564Q1529 711 1486 792T1306 874Q1214 874 1161 831T1085 712T1062 540Q1062 395 1123 310T1306 224Q1377 224 1432 258T1517 360L1774 282Q1737 184 1667 114T1507 7T1321 -30ZM498 182Q581 182 646 223T740 312Q756 340 765 373T777 446T778 532L876 498L648 470Q609 466 558 457T458 429T378 379T346 300Q346 249 386 216T498 182ZM454 -30Q273 -30 177 61T80 290Q80 376 114 436T205 534T330 596T466 631T592 650L838 682L774 630Q785 718 760 768T686 840T580 862Q510 862 451 830T362 730L118 804Q154 886 218 955T375 1067T588 1110Q764 1110 873 1038T1022 840Q1040 782 1043 728T1046 644L908 212Q855 126 787 73T636 -5T454 -30ZM982 464V674H1659V464H982Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 1166,
    d: "M586 -484Q544 -484 509 -473T444 -446L502 -290Q541 -302 562 -302Q589 -302 603 -287T618 -256Q618 -220 580 -203T488 -170L558 34L716 36L680 -72Q739 -102 770 -149T802 -262Q802 -361 738 -422T586 -484ZM616 -30Q448 -30 328 45T144 249T80 540Q80 704 146 833T334 1036T620 1110Q811 1110 940 1014T1106 750L834 678Q810 762 751 809T616 856Q530 856 475 815T394 702T368 540Q368 399 430 312T616 224Q708 224 756 266T828 386L1106 328Q1060 156 932 63T616 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1216,
    d: "M523 1230L357 1620H559L725 1230H523ZM642 -30Q476 -30 350 41T152 238T80 526Q80 703 150 834T343 1037T626 1110Q796 1110 915 1030T1091 805T1131 464H862V564Q862 729 810 801T638 874Q499 874 434 790T368 540Q368 389 433 307T626 224Q706 224 763 259T850 360L1122 282Q1061 134 930 52T642 -30ZM284 464V666H1000V464H284Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1216,
    d: "M749 1230H547L713 1620H915L749 1230ZM642 -30Q476 -30 350 41T152 238T80 526Q80 703 150 834T343 1037T626 1110Q796 1110 915 1030T1091 805T1131 464H862V564Q862 729 810 801T638 874Q499 874 434 790T368 540Q368 389 433 307T626 224Q706 224 763 259T850 360L1122 282Q1061 134 930 52T642 -30ZM284 464V666H1000V464H284Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1216,
    d: "M222 1230L510 1560H734L1022 1230H772L622 1410L472 1230H222ZM642 -30Q476 -30 350 41T152 238T80 526Q80 703 150 834T343 1037T626 1110Q796 1110 915 1030T1091 805T1131 464H862V564Q862 729 810 801T638 874Q499 874 434 790T368 540Q368 389 433 307T626 224Q706 224 763 259T850 360L1122 282Q1061 134 930 52T642 -30ZM284 464V666H1000V464H284Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1216,
    d: "M718 1232V1472H958V1232H718ZM294 1232V1472H534V1232H294ZM642 -30Q476 -30 350 41T152 238T80 526Q80 703 150 834T343 1037T626 1110Q796 1110 915 1030T1091 805T1131 464H862V564Q862 729 810 801T638 874Q499 874 434 790T368 540Q368 389 433 307T626 224Q706 224 763 259T850 360L1122 282Q1061 134 930 52T642 -30ZM284 464V666H1000V464H284Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 592,
    d: "M191 1230L25 1620H227L393 1230H191ZM160 0V1080H432V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 592,
    d: "M401 1230H199L365 1620H567L401 1230ZM160 0V1080H432V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 592,
    d: "M-88 1230L200 1560H424L712 1230H462L312 1410L162 1230H-88ZM160 0V1080H432V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 592,
    d: "M388 1232V1472H628V1232H388ZM-36 1232V1472H204V1232H-36ZM160 0V1080H432V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 1202,
    d: "M602 -30Q448 -30 331 37T147 225T80 502Q80 660 146 780T330 968T602 1036Q668 1036 727 1021T866 966Q853 1051 784 1127T614 1255T402 1314L444 1520Q597 1516 717 1461T920 1304Q992 1216 1036 1106T1101 850T1122 510Q1122 345 1059 224T878 36T602 -30ZM602 210Q719 210 784 287T850 504Q850 642 785 719T602 796Q481 796 417 721T352 504Q352 363 417 287T602 210ZM640 1058L492 1190L822 1566L970 1434L640 1058Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 1272,
    d: "M810 1236Q761 1236 717 1258T632 1310T556 1361T492 1384Q462 1384 451 1351T452 1266H284Q253 1397 296 1487T466 1578Q515 1578 559 1556T644 1504T720 1453T784 1430Q814 1430 826 1463T824 1548H992Q1024 1418 980 1327T810 1236ZM876 0V510Q876 547 872 604T847 720T779 817T644 856Q609 856 569 845T494 803T437 710T414 548L258 622Q258 750 310 862T466 1043T730 1112Q857 1112 937 1069T1061 960T1125 823T1148 692T1152 606V0H876ZM138 0V1080H380V722H414V0H138Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1254,
    d: "M513 1230L347 1620H549L715 1230H513ZM626 -30Q463 -30 340 43T149 244T80 540Q80 709 150 837T343 1038T626 1110Q789 1110 912 1037T1105 836T1174 540Q1174 372 1105 244T912 43T626 -30ZM626 224Q757 224 821 312T886 540Q886 684 821 770T626 856Q537 856 480 816T396 705T368 540Q368 395 433 310T626 224Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1254,
    d: "M731 1230H529L695 1620H897L731 1230ZM626 -30Q463 -30 340 43T149 244T80 540Q80 709 150 837T343 1038T626 1110Q789 1110 912 1037T1105 836T1174 540Q1174 372 1105 244T912 43T626 -30ZM626 224Q757 224 821 312T886 540Q886 684 821 770T626 856Q537 856 480 816T396 705T368 540Q368 395 433 310T626 224Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1254,
    d: "M224 1230L512 1560H736L1024 1230H774L624 1410L474 1230H224ZM626 -30Q463 -30 340 43T149 244T80 540Q80 709 150 837T343 1038T626 1110Q789 1110 912 1037T1105 836T1174 540Q1174 372 1105 244T912 43T626 -30ZM626 224Q757 224 821 312T886 540Q886 684 821 770T626 856Q537 856 480 816T396 705T368 540Q368 395 433 310T626 224Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1254,
    d: "M800 1236Q751 1236 707 1258T622 1310T546 1361T482 1384Q452 1384 441 1351T442 1266H274Q243 1397 286 1487T456 1578Q505 1578 549 1556T634 1504T710 1453T774 1430Q804 1430 816 1463T814 1548H982Q1014 1418 970 1327T800 1236ZM626 -30Q463 -30 340 43T149 244T80 540Q80 709 150 837T343 1038T626 1110Q789 1110 912 1037T1105 836T1174 540Q1174 372 1105 244T912 43T626 -30ZM626 224Q757 224 821 312T886 540Q886 684 821 770T626 856Q537 856 480 816T396 705T368 540Q368 395 433 310T626 224Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1254,
    d: "M720 1232V1472H960V1232H720ZM296 1232V1472H536V1232H296ZM626 -30Q463 -30 340 43T149 244T80 540Q80 709 150 837T343 1038T626 1110Q789 1110 912 1037T1105 836T1174 540Q1174 372 1105 244T912 43T626 -30ZM626 224Q757 224 821 312T886 540Q886 684 821 770T626 856Q537 856 480 816T396 705T368 540Q368 395 433 310T626 224Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    horizAdvX: 1080,
    d: "M120 616V826H960V616H120ZM504 902V1174H776V902H504ZM504 418V690H776V418H504Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1254,
    d: "M236 -30L56 150L238 332L320 372L832 882L852 944L1018 1110L1198 928L1024 756L958 730L456 228L406 140L236 -30ZM626 -30Q463 -30 340 43T149 244T80 540Q80 709 150 837T343 1038T626 1110Q789 1110 912 1037T1105 836T1174 540Q1174 372 1105 244T912 43T626 -30ZM626 224Q757 224 821 312T886 540Q886 684 821 770T626 856Q537 856 480 816T396 705T368 540Q368 395 433 310T626 224Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 1272,
    d: "M522 1230L356 1620H558L724 1230H522ZM542 -32Q415 -32 335 11T211 120T147 257T124 388T120 474V1080H396V570Q396 533 400 476T425 360T493 263T628 224Q663 224 703 235T778 277T835 370T858 532L1014 458Q1014 330 962 218T806 37T542 -32ZM892 0V358H858V1080H1132V0H892Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 1272,
    d: "M715 1230H513L679 1620H881L715 1230ZM542 -32Q415 -32 335 11T211 120T147 257T124 388T120 474V1080H396V570Q396 533 400 476T425 360T493 263T628 224Q663 224 703 235T778 277T835 370T858 532L1014 458Q1014 330 962 218T806 37T542 -32ZM892 0V358H858V1080H1132V0H892Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 1272,
    d: "M222 1230L510 1560H734L1022 1230H772L622 1410L472 1230H222ZM542 -32Q415 -32 335 11T211 120T147 257T124 388T120 474V1080H396V570Q396 533 400 476T425 360T493 263T628 224Q663 224 703 235T778 277T835 370T858 532L1014 458Q1014 330 962 218T806 37T542 -32ZM892 0V358H858V1080H1132V0H892Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 1272,
    d: "M718 1232V1472H958V1232H718ZM294 1232V1472H534V1232H294ZM542 -32Q415 -32 335 11T211 120T147 257T124 388T120 474V1080H396V570Q396 533 400 476T425 360T493 263T628 224Q663 224 703 235T778 277T835 370T858 532L1014 458Q1014 330 962 218T806 37T542 -32ZM892 0V358H858V1080H1132V0H892Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 1140,
    d: "M688 1230H486L652 1620H854L688 1230ZM278 -480L486 92L490 -76L20 1080H302L618 262H554L868 1080H1140L530 -480H278Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1248,
    d: "M140 864V1440H414V864H140ZM670 -30Q509 -30 401 45T239 249T184 540Q184 702 238 831T397 1035T656 1110Q811 1110 926 1036T1104 834T1168 540Q1168 378 1106 249T931 45T670 -30ZM138 -480V1080H378V340H412V-480H138ZM626 212Q714 212 770 256T853 374T880 540Q880 630 852 704T766 823T616 868Q531 868 479 827T402 712T378 540Q378 442 402 368T480 253T626 212Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 1140,
    d: "M676 1232V1472H916V1232H676ZM252 1232V1472H492V1232H252ZM278 -480L486 92L490 -76L20 1080H302L618 262H554L868 1080H1140L530 -480H278Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1080,
    d: "M120 526V736H960V526H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 1560,
    d: "M120 526V736H1440V526H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 610,
    d: "M430 898Q292 876 225 950T158 1168V1440H430V1168H290Q283 1120 294 1084T336 1028T414 1012L430 898Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 610,
    d: "M180 898L196 1012Q244 1008 274 1027T315 1083T320 1168H180V1440H452V1168Q452 1024 385 950T180 898Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 632,
    d: "M120 -270L136 -156Q184 -160 214 -141T255 -85T260 0H120V272H392V0Q392 -144 325 -218T120 -270Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 954,
    d: "M794 1440L778 1326Q730 1330 700 1311T659 1255T654 1170H794V898H522V1170Q522 1314 589 1388T794 1440ZM432 1440L416 1326Q368 1330 338 1311T297 1255T292 1170H432V898H160V1170Q160 1314 227 1388T432 1440Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 954,
    d: "M160 898L176 1012Q224 1008 254 1027T295 1083T300 1168H160V1440H432V1168Q432 1024 365 950T160 898ZM522 898L538 1012Q586 1008 616 1027T657 1083T662 1168H522V1440H794V1168Q794 1024 727 950T522 898Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 954,
    d: "M160 -270L176 -156Q224 -160 254 -141T295 -85T300 0H160V272H432V0Q432 -144 365 -218T160 -270ZM522 -270L538 -156Q586 -160 616 -141T657 -85T662 0H522V272H794V0Q794 -144 727 -218T522 -270Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 1440,
    d: "M726 330Q641 330 572 369T461 477T420 630Q420 716 461 784T572 891T726 930Q806 930 873 891T980 784T1020 630Q1020 545 980 477T873 370T726 330Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 1290,
    d: "M764 146L280 630L764 1114L932 946L604 630L932 314L764 146Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 1290,
    d: "M526 146L358 314L686 630L358 946L526 1114L1010 630L526 146Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManropeV13Latin800);
export default __webpack_public_path__ + "static/media/manrope-v13-latin-800.6183c7b1b0b648518a94c4ab211b4745.svg";
export { ForwardRef as ReactComponent };